import type { GameContent } from "@bastion/data";
import type { GameState } from "@bastion/game-core";

export interface ReplayGlobalSkillState {
  id: string;
  icon: string;
  cost: number;
  cooldown: number;
  cooldownRemaining: number;
  ready: boolean;
}

export interface ReplayHudState {
  gold: number;
  lives: number;
  maxLives: number;
  wave: number;
  totalWaves: number;
  isEndless: boolean;
  livingEnemies: number;
  elapsedSeconds: number;
  skills: ReplayGlobalSkillState[];
}

/** 只从回放自身的 Engine 状态构造播放器 HUD，不读取主页 HUD 快照。 */
export function createReplayHudState(
  state: GameState,
  content: GameContent,
  engineTime: number,
  isDebug: boolean,
): ReplayHudState {
  const now = Number.isFinite(engineTime) ? engineTime : state.time;
  return {
    gold: state.gold,
    lives: state.baseHp,
    maxLives: state.maxHp,
    wave: state.wave,
    totalWaves: state.totalWaves,
    isEndless: state.isEndless === true,
    livingEnemies: state.enemies.filter((enemy) => enemy.alive).length,
    elapsedSeconds: now,
    skills: Object.values(content.skills)
      .filter((skill) => skill.type === "GLOBAL")
      .map((skill) => {
        const cooldownEnd = state.skillCooldowns.find(
          (cooldown) => cooldown.id === skill.id,
        )?.cooldownEnd;
        const cooldownRemaining = isDebug ? 0 : Math.max(0, (cooldownEnd ?? now) - now);
        return {
          id: skill.id,
          icon: skill.icon ?? "✨",
          cost: skill.cost,
          cooldown: skill.cooldown,
          cooldownRemaining,
          ready: cooldownRemaining === 0,
        };
      }),
  };
}
